import axios from 'axios'

var instance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL + '/api'
})
instance.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'

export default instance
